import { useTranslation } from 'react-i18next';
import { formatNumberWithSpaces } from 'pages/calculator/MediaPlanning/common/BudgetTable/utils/formatNumberWithSpaces';
import { SxProps, TableCell, TableRow, Typography } from '@mui/material';
import { ResponseCopy } from '../../../../../../../../../../store/planStore';
import convertDecimalToPercentValue from '../../../../../utils/convertDecimalToPercentValue';

interface BudgetTableRowProps {
  rowData: ResponseCopy;
  touchpoint?: string;
  sx?: SxProps;
}

function BudgetTableRow({ rowData, touchpoint, sx }: BudgetTableRowProps) {
  const { t } = useTranslation();
  return (
    <TableRow>
      <TableCell align="left">
        <Typography variant="body2" fontWeight={700} textTransform="uppercase">
          {t(touchpoint ?? '')}
        </Typography>
      </TableCell>
      <TableCell align="left">
        <Typography variant="body2" fontWeight={700}>
          {formatNumberWithSpaces(rowData.name)}
        </Typography>
      </TableCell>
      <TableCell align="right">
        <Typography variant="body2" fontWeight={700}>
          {formatNumberWithSpaces(rowData.weeks)}
        </Typography>
      </TableCell>
      <TableCell align="center">
        <Typography variant="body2" fontWeight={700}>
          {formatNumberWithSpaces(rowData.totalGrp)}
        </Typography>
      </TableCell>
      <TableCell align="center">
        <Typography variant="body2" fontWeight={700}>
          {convertDecimalToPercentValue(rowData.split)}
        </Typography>
      </TableCell>
      <TableCell align="right">
        <Typography variant="body2" fontWeight={700}>
          {formatNumberWithSpaces(rowData.campaignBudget.value.toFixed(0))}
        </Typography>
      </TableCell>
    </TableRow>
  );
}

export default BudgetTableRow;
